
new Swiper('.lists-slider', {
     navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
     },
     breakpoints: {
        1400: {
          slidesPerView: 4,
          spaceBetween: 20,
        },
        990: {
          slidesPerView: 3.1,
          spaceBetween: 20,
        },
        750: {
          slidesPerView: 2.1,
          spaceBetween: 15,
        },
        0: {
          slidesPerView: 1.2,
          spaceBetween: 15,
        },
     },
});
